import React from "react";
import airbnb from "../../assets/images/avatar-placeholder-icon.svg";
import bookingCom from "../../assets/images/BookingCom.svg";

import FilledStar from "../../assets/images/filled-start.svg";
import moment from "moment";

type Testimonial = {
  guest_name: string;
  content: string;
  ota: string;
  received_at: Date | string;
  overall_score: string | number;
};

type TestimonialCardProps = {
  setShowTestimonialBox: React.Dispatch<React.SetStateAction<boolean>>;
  setSelectedTestimonial: React.Dispatch<React.SetStateAction<Testimonial[]>>;
  item: Testimonial;
};

const TestimonialCard: React.FC<TestimonialCardProps> = ({
  setShowTestimonialBox,
  setSelectedTestimonial,
  item,
}) => {
  const channelLogo = () => {
    if (item?.ota === "BookingCom") {
      return bookingCom;
    } else if (item?.ota === "AirBNB") {
      return airbnb;
    }
  };
  return (
    <div
      onClick={() => {
        setSelectedTestimonial([item]);
        setShowTestimonialBox(true);
      }}
      className='customer-feedback-box cursor-pointer bg-white'
    >
      <div className='flex flex-col gap-3'>
        <div className='flex intro flex-col'>
          <p className='flex align-middle gap-2 items-center'>
            <span>{item?.guest_name}</span>
            <img src={channelLogo()} alt='avatar placeholder' />
          </p>
          <span>
            {[moment(item?.received_at).fromNow(), item?.ota].filter(Boolean).join(" · ")}
          </span>
          <p className='flex !gap-1 review align-middle items-center'>
            <img src={FilledStar} width={8} alt='star' />
            {Number(item?.overall_score) > 0 && (
              <span>{item?.overall_score}/10 . </span>
            )}
            <span>{moment(item?.received_at).format("DD.MM.YYYY")}</span>
          </p>
        </div>
        <p className='content break-all'>{item?.content}</p>
      </div>
    </div>
  );
};

export default TestimonialCard;
